/**
 * 静态资源路径规范
 *
 * 团队文件上传目录：frontend/assets/ka/cipp
 * CDN 根路径：https://static.huashicloud.com/assets/ka/cipp
 *
 * @module constants/static-assets
 */

import { getStaticAssetUrl } from '@/env';

/** 静态资源子目录 */
export const STATIC_ASSETS_DIRS = {
  /** 全局资源：logo、favicon 等 */
  global: 'image/global',
  /** 首页用图 */
  home: 'image/home',
  /** 新闻页用图 */
  news: 'image/news',
  /** 活动页用图 */
  activity: 'image/activity',
  /** 关于我们页用图 */
  about: 'image/about',
  /** 云端展览列表 banner */
  database: 'image/database',
  /** 页脚用图 */
  footer: 'image/footer',
} as const;

/**
 * 按分类获取静态资源完整 CDN 地址
 * @param dir - STATIC_ASSETS_DIRS 中的 key
 * @param filename - 文件名
 */
export const getAssetUrlByDir = (
  dir: keyof typeof STATIC_ASSETS_DIRS | string,
  filename: string,
): string => {
  const rawPath = typeof dir === 'string' ? dir : STATIC_ASSETS_DIRS[dir];
  const path = rawPath.startsWith('image/') ? rawPath : `image/${rawPath}`;
  const fullPath = `${path.replace(/\/$/, '')}/${filename.replace(/^\//, '')}`;
  return getStaticAssetUrl(fullPath);
};

/**
 * 导航栏 Logo 图片文件名（上传目录：frontend/assets/ka/cipp/image/global/）
 */
export const LOGO_ASSETS = {
  /** CIPP 主 Logo 图标 */
  cippLogo: 'cipplogo4.png',
  /** ICUA Logo 图标（导航栏右侧） */
  icuaLogo: 'icua.png',
  /** 浏览器标签 favicon（上传目录：image/global/llogo.png） */
  favicon: 'llogo.png',
} as const;

/**
 * 首页图片文件名（上传目录：frontend/assets/ka/cipp/image/home/）
 */
export const HOME_PAGE_ASSETS = {
  /** 活动卡片「正在进行」角标图标 */
  activityOngoingIcon: 'Frame.svg',
  /** 活动卡片「已结束」角标图标 */
  activityEndedIcon: 'Vector.svg',
} as const;

/**
 * 关于我们页图片文件名（上传目录：frontend/assets/ka/cipp/image/about/）
 */
export const ABOUT_PAGE_ASSETS = {
  /** PC 页头 Hero（中文） */
  pcHero: '26aboutus1.png',
  /** PC 页头 Hero（英文） */
  pcHeroEn: '26aboutus1_en.png',
  /** H5 页头 Hero（中文） */
  h5Hero: '26kv3.png',
  /** H5 页头 Hero（英文） */
  h5HeroEn: '26kv2_en.png',
  /** 愿景卡片图标，建议 64×64 PNG 透明底 */
  visionIcon: 'about-vision-icon.svg',
  /** 使命卡片图标，建议 64×64 PNG 透明底 */
  missionIcon: 'about-mission-icon.svg',
} as const;
